import { NarratorNPC } from '../../../../src/feature/narrator/narrator.model';
import { dialog } from './dialog';

export const townsfolk: NarratorNPC = {
  id: 'townsfolk',
  name: 'Townsfolk',
  dialog: dialog,
};
